import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/fr'

dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.locale('fr')

export default dayjs
